import React, { useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FaWhatsapp } from "react-icons/fa";

import "../App.css";

import contactImage from "../assets/contact-us.jpg";

const WHATSAPP_LINK =
  "https://wa.me/923435350202?text=" +
  encodeURIComponent("Hi, I'd like to talk to Epaging about a project.");

function Contact() {
  const formRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = formRef.current;
    const token = window.grecaptcha && window.grecaptcha.getResponse();
    if (!token) {
      alert("Please complete the reCAPTCHA check and try again.");
      return;
    }
    const data = Object.fromEntries(new FormData(form).entries());
    delete data["g-recaptcha-response"];
    data.recaptchaToken = token;

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error("Submission failed");
      alert("Message sent successfully!");
      form.reset();
    } catch (error) {
      console.error("Contact form send error:", error);
      alert("Failed to send message. Please try again.");
    } finally {
      if (window.grecaptcha) window.grecaptcha.reset();
    }
  };

  return (
    <div className="page-wrapper">
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <section className="contact-intro">
            <div className="container">
              <div className="sec-title text-center">
                <h3 className="sec-title__title bw-split-text">
                  Let's Talk
                </h3>
              </div>

              <div className="contact-cta-row">
                <a href="tel:+922134327000" className="contact-cta-row__btn contact-cta-row__btn--outline">
                  <FontAwesomeIcon icon={faPhone} />
                  Call Now
                </a>
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-cta-row__btn contact-cta-row__btn--whatsapp"
                >
                  <FaWhatsapp />
                  Chat on WhatsApp
                </a>
                <a href="#message-form" className="contact-cta-row__btn contact-cta-row__btn--outline">
                  <FontAwesomeIcon icon={faEnvelope} />
                  Send a Message
                </a>
              </div>
            </div>
          </section>

          <section className="contact-three section-space-bottom" id="message-form">
            <div className="container">
              <div className="row gutter-y-30">
                <div className="col-xl-8 col-lg-7">
                  <div className="contact-three__wrapper">
                    <div className="sec-title text-left">
                      <h6 className="sec-title__tagline bw-split-text">
                        Send A Message
                      </h6>
                      <h3 className="sec-title__title bw-split-text">
                        Tell us what you need
                      </h3>
                    </div>

                    <form
                      ref={formRef}
                      onSubmit={handleSubmit}
                      className="contact-three__form contact-form-validated form-one"
                      data-aos="fade-up"
                      data-aos-duration="1200"
                      data-aos-delay="300"
                    >
                      <div className="form-one__group">
                        <div className="form-one__control">
                          <input
                            type="text"
                            name="name"
                            placeholder="Your Name*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <input
                            type="email"
                            name="email"
                            placeholder="E-mail Address*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <input
                            type="tel"
                            name="phone"
                            placeholder="Phone Number*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <input
                            type="text"
                            name="subject"
                            placeholder="Subject*"
                            required
                          />
                        </div>

                        <div className="form-one__control form-one__control--full">
                          <textarea
                            name="message"
                            placeholder="Write message"
                            required
                          ></textarea>
                        </div>
                        <div className="form-one__control form-one__control--full">
                          <div className="g-recaptcha" data-sitekey="6LddCc8tAAAAAGvdPLdnsJTVovstlArW1xkcqH1P"></div>
                        </div>
                        <div className="form-one__control form-one__control--full">
                          <button type="submit" className="lotech-btn">
                            <span>
                              Send Message
                              <span className="lotech-btn__icon">
                                <i className="flaticon-up-right-arrow"></i>
                                <i className="flaticon-up-right-arrow"></i>
                              </span>
                            </span>
                          </button>
                        </div>
                      </div>
                    </form>
                    <div className="result"></div>
                  </div>
                </div>

                {/* Right Side - Contact Image */}
                <div
                  className="col-xl-4 col-lg-5"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div
                    className="contact-three__image"
                    data-speed="1.1"
                    data-lag="0"
                  >
                    <img src={contactImage} alt="Contact Us" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="contact-map-compact section-space-bottom">
            <div className="container">
              <div className="row gutter-y-24 align-items-center">
                <div className="col-lg-6">
                  <div className="google-map google-map__contact">
                    <iframe
                      title="Google Map"
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d455.3831190506045!2d67.06650865773572!3d24.880904157824915!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33f3ced2921c1%3A0x36cc7a708d85a2d9!2sEpaging%20Pvt%20Ltd!5e1!3m2!1sen!2sus!4v1746554499000!5m2!1sen!2sus"
                      className="map__contact"
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
                <div className="col-lg-6">
                  <ul className="contact-strip list-unstyled">
                    <li>
                      <FontAwesomeIcon icon={faLocationDot} />
                      <a
                        href="https://maps.app.goo.gl/GeA5emFtzyRDtan86"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Plot # 16/74, Block-3, Bahadur Yar Jang Cooperative
                        Housing Society, Karachi, Pakistan.
                      </a>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faPhone} />
                      <a href="tel:02134327000">(021) 343-27-000</a>
                      <span className="contact-strip__sep">/</span>
                      <a href="tel:+18889982766">(+1) 888-998-2766</a>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faEnvelope} />
                      <a href="mailto:info@epaging.net">info@epaging.net</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Contact;
